import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { ActivityLevel, Data } from './services/data';
import { normalizeString } from './services/util';
import { Messenger } from './services/messenger';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
var PersonalInfoComponent = /** @class */ (function () {
    function PersonalInfoComponent(data, messenger, location, route) {
        this.data = data;
        this.messenger = messenger;
        this.location = location;
        this.route = route;
        this.activityLevels = Object.getOwnPropertyNames(ActivityLevel).map(function (name) { return ActivityLevel[name]; });
        this.onSave = new EventEmitter();
    }
    PersonalInfoComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, user;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = this.route.snapshot.paramMap.get('id');
                        if (!id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.data.users.get(id)];
                    case 1:
                        user = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.data.getLatestUser()];
                    case 3:
                        user = _a.sent();
                        user = Object.assign({}, user);
                        delete user.id;
                        user.updated = +moment();
                        _a.label = 4;
                    case 4:
                        if (user) {
                            this.weight = user.weight;
                            this.heightFeet = Math.floor(user.height / 12);
                            this.heightInches = user.height - (this.heightFeet * 12);
                            this.age = user.age;
                            this.bodyFatPercent = user.bodyFatPercentage;
                            this.activityLevel = user.activityLevel;
                            this.weightTarget = user.weightTarget;
                            this.updated = user.updated;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PersonalInfoComponent.prototype.saveInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var user, firstMissing;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = this.infoAsUser();
                        firstMissing = Object.getOwnPropertyNames(user).find(function (name) { return name !== 'id' && user[name] === undefined; });
                        if (firstMissing) {
                            return [2 /*return*/, this.messenger.send(normalizeString(firstMissing) + " is required", true)];
                        }
                        if (!user.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.data.updateUser(user).then(function () {
                                _this.location.back();
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.data.addUser(user).then(function () {
                            _this.onSave.emit();
                            if (_this.location.isCurrentPathEqualTo('/personal-info/add')) {
                                _this.location.back();
                            }
                        })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PersonalInfoComponent.prototype.infoAsUser = function () {
        var ret = {
            weight: this.weight,
            height: (this.heightInches || 0) + (this.heightFeet * 12),
            age: this.age,
            bodyFatPercentage: this.bodyFatPercent,
            activityLevel: this.activityLevel,
            weightTarget: this.weightTarget,
            updated: this.updated || moment(),
            deleted: false,
        };
        var id = this.route.snapshot.paramMap.get('id');
        if (id && id.length !== 0) {
            ret.id = id;
        }
        return ret;
    };
    return PersonalInfoComponent;
}());
export { PersonalInfoComponent };
